
import React  from 'react'
// import noteContext from '../context/noteContext'

const About = () => {
  
    return (
        <div>
            This is About page
        </div>
    )
}

export default About
